import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    actionButton: { fontSize: '0.6875rem' },
    root: {
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      position: 'relative',
    },
  };
};
